<template>
	<div class="footer-links-list mr">
		<h2>Our Company</h2>

		<a href="/rewards/">Blain's Rewards</a>
		<a href="/mobile-app/">Mobile App</a>
		<a href="/about-us/">About Us</a>
		<a href="https://www.farmandfleet.com/blog/">Blain's Blog</a>
		<a href="https://careers.farmandfleet.com/" target="_blank" rel="noopener">Careers at Blain's</a>
		<a href="https://realestate.farmandfleet.com/" target="_blank" rel="noopener">Real Estate</a>

		<div class="footer-divider"></div>

		<h2>Blain's Mastercard</h2>
		<a href="https://www.card.fnbo.com/" target="_blank" rel="noopener">Pay and Manage Card</a>
		<a href="/mastercard/">Apply for the Card</a>
	</div>
</template>

<script>
export default {
	name: 'CompanyLinks'
};
</script>